export class LanguageHelper {
    static DEFAULT_LANGUAGE = `fa-rIR`;

    static currentLanguage = LanguageHelper.DEFAULT_LANGUAGE;

    static getLanguageCode() {
        return LanguageHelper.DEFAULT_LANGUAGE;
    }


    static setLanguage(language) {
        LanguageHelper.currentLanguage = language;
    }

}